'use client'

import { useMemo } from 'react'

const CreatedDate = ({ created_at }: { created_at?: number }) => {
  const formattedCreatedDate: string = useMemo(() => {
    if (!created_at) return ''
    const date = new Date(created_at * 1000)
    const month: string = date
      .toLocaleString('en', { month: 'numeric' })
      .padStart(2, '0')
    const day: string = date
      .toLocaleString('en', { day: 'numeric' })
      .padStart(2, '0')
    const year: string = date.toLocaleString('en', { year: 'numeric' })
    return `${year}/${month}/${day}`
  }, [created_at])

  return <>{formattedCreatedDate}</>
}

export default CreatedDate
